module.exports = __webpack_public_path__ + "img/logo.281d1f74.png";